<template>
  <div>
    <!-- <Header /> -->

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="p-10 flex flex-col gap-5">
          <div class="flex justify-end">
            <router-link
              :to="{ name: 'GradeBook', query: { fromTab: 'assessment' } }"
              class="cursor-pointer bg-blues hover:bg-blue-600 text-white px-3 py-1 text-sm font-bold rounded-2xl"
            >
              Back
            </router-link>
          </div>

          <div class="flex flex-col md:flex-row gap-3 justify-between">
            <div>
              <h1 class="text-blues font-semibold">{{ assessment_title }}</h1>
            </div>
            <div class="flex gap-5 items-center">
              <div class="relative max-w-64">
                <form @submit.prevent="getassessmenttails(1)">
                  <input
                    type="text"
                    placeholder="Search"
                    id="search"
                    v-model="searching"
                    @input="getassessmenttails(1)"
                    class="w-full pl-4 pr-10 py-2 border border-gray-300 rounded-full bg-[#F0F5F9] text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-300"
                  />
                  <button type="submit" class="">
                    <div class="absolute right-3 top-2.5 h-5 w-5 text-gray-400">
                      <img src="@/assets/search_icon1.svg" alt="" srcset="" />
                    </div>
                  </button>
                </form>
              </div>
              <button class="px-4 py-1 bg-blues text-white rounded-md hover:bg-blue-600"   @click="Assessdownload()">
                Download
              </button>
            </div>
          </div>
          <div>
            <div
              class="overflow-x-auto rounded-lg shadow border border-gray-200"
            >
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-100 whitespace-nowrap">
                  <tr class="text-left bg-blues  text-white text-sm">
                    <th class="px-4 py-2">S.No</th>
                    <th class="px-4 py-2">Name</th>
                    <th class="px-4 py-2 text-center">Mark</th>
                    <th class="px-4 py-2">Complete Date</th>
                  </tr>
                </thead>
                <tbody
                  v-if="assessments.length > 0"
                  class="divide-y divide-gray-100 text-sm whitespace-nowrap"
                >
                  <tr
                    v-for="(assessment, index) in assessments"
                    :key="index"
                    class="hover:bg-gray-50"
                  >
                    <td class="px-4 py-2 font-medium text-gray-800">
                      {{ (currentPage - 1) * 10 + index + 1 }}
                    </td>
                    <td class="px-4 py-2 text-gray-700">
                      {{ assessment?.user?.display_name || "Na" }}
                    </td>
                    <td class="px-4 py-2 text-center text-gray-700">
                      {{ assessment.score }} / {{ assessment.quiz.total_score }}
                    </td>

                    <td class="px-4 py-2 text-gray-600">
                      {{ formatDate(assessment.finished_at) }}
                    </td>
                  </tr>
                </tbody>
                <tr v-else>
                  <td colspan="11" class="px-6 py-3 text-center">
                    No Data Found
                  </td>
                </tr>
              </table>
            </div>
            <Pagination
              :totalPages="totalPages"
              ref="paginationRef"
              @page-changed="getassessmenttails"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import SideBar from "@/components/Instructor/SideBar.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import Pagination from "@/components/Pagination.vue";

import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: {
    Header,
    SideBar,
    FlashMessage,
    Pagination,
  },
  data() {
    return {
      userSelectList: [],

      messages: {
        text: "",
        type: "null",
      },
      loading: true,
      currentPage: 1,
      totalPages: 1,
      tab: "assignment",
      assessments: [],
      searching: "",
    };
  },
  created() {
    this.getassessmenttails(1);
  },

  props: ["assessment_id", "course_id", "assessment_title"],

  computed: {
    ...mapGetters(["userInfo"]),
  },

  methods: {
    formatDate(date) {
  if (!date) return '';
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${year}-${month}-${day}`;
},
   async getassessmenttails(page) {
  this.currentPage = page;
  this.loading = true;

  await axios
    .get(
      `${process.env.VUE_APP_API}/coursequize/taker/list/?Key=${this.userInfo.token_key}&page=${page}&completed=true&quiz__id=${this.assessment_id}&search=${this.searching}`
    )
    .then((response) => {
      if (response.data.status == 200) {
        this.totalPages = response.data.data?.total_page;
        this.assessments = response.data.data?.data?.data || [];
        console.log("this.studentList/////////:::::::", this.assessments);
      } else if (response.data.status == 400) {
        this.assessments = [];
      }
      this.loading = false;
    })
    .catch((error) => {
      console.error("Error:", error);
      this.assessments = [];
      this.loading = false;
    });
},
  async Assessdownload() {
    window.location.href = `${process.env.VUE_APP_API}/coursequize/taker/list/?Key=${this.userInfo.token_key}&completed=true&quiz__id=${this.assessment_id}&download=True`;
    },

  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
